export const fetchAuthTokens = async () => {
    const config = useRuntimeConfig();
    
    try {
        const response = await $fetch(`${config.public.apiUrl}/confirm-auth`, {
            method: 'GET',
            credentials: 'include',
        });
        
        // Handle both wrapped and unwrapped response formats
        const data = response.data || response;
        
        // If API returns cookie info, return it
        if (data && data.rst && data.uat && data.uid) {
            return {
                arst: data.rst,
                auat: data.uat,
                uid: data.uid
            };
        }
    } catch (error) {
        console.error('Failed to call confirm-auth API:', error);
    }
    
    return null;
};

export const setAuthCookies = (tokens) => {
    if (!tokens) return false;
    
    const expires = new Date(Date.now() + 1800 * 1000); // 30 minutes
    const cookieOptions = {
        path: '/',
        secure: true,
        sameSite: 'lax',
        expires: expires
    };
    
    const arst = useCookie('arst', cookieOptions);
    const auat = useCookie('auat', cookieOptions);
    const uid = useCookie('uid', cookieOptions);
    
    arst.value = tokens.arst;
    auat.value = tokens.auat;
    uid.value = tokens.uid;
    
    return true;
};

export const checkAndFetchAuth = async () => {
    const arst = useCookie('arst');
    const auat = useCookie('auat');

    if (arst.value && auat.value) {
        return true;
    }
    
    // Try to fetch auth tokens
    const tokens = await fetchAuthTokens();
    
    // Set cookies if we got valid tokens
    if (tokens) {
        return setAuthCookies(tokens);
    }

    return false;
};